import React, { useState, useRef, useEffect, useCallback } from 'react';

// Middle-earth map — free Wikia / Fandom hosted map. Swap by editing this constant.
const MIDDLE_EARTH_IMAGE = 'https://static.wikia.nocookie.net/lotr/images/8/8b/Middle-earth_map.jpg';

// Named locations positioned as % of the map image (0-100).
// Western Middle-earth roughly fills 15-75% horizontally, 10-80% vertically.
const LOCATIONS = [
  // ═══ The Shire ═══
  { id: 'hobbiton', name: 'Hobbiton', x: 20, y: 34, region: 'The Shire', major: true },
  { id: 'bywater', name: 'Bywater', x: 21, y: 34, region: 'The Shire' },
  { id: 'bucklebury', name: 'Bucklebury Ferry', x: 24, y: 35, region: 'The Shire' },
  { id: 'brandywine_bridge', name: 'Brandywine Bridge', x: 24, y: 33, region: 'The Shire' },
  { id: 'tuckborough', name: 'Tuckborough', x: 20, y: 36, region: 'The Shire' },

  // ═══ Eriador ═══
  { id: 'bree', name: 'Bree', x: 28, y: 35, region: 'Eriador', major: true },
  { id: 'weathertop', name: 'Weathertop', x: 34, y: 36, region: 'Eriador' },
  { id: 'bruinen', name: 'Ford of Bruinen', x: 41, y: 37, region: 'Eriador' },
  { id: 'rivendell', name: 'Rivendell', x: 44, y: 37, region: 'Eriador', major: true },
  { id: 'grey_havens', name: 'Grey Havens', x: 14, y: 34, region: 'Eriador', major: true },
  { id: 'fornost', name: 'Fornost (Ruined)', x: 25, y: 28, region: 'Eriador' },
  { id: 'tharbad', name: 'Tharbad', x: 36, y: 45, region: 'Eriador' },
  { id: 'angmar', name: 'Angmar (Ruined)', x: 35, y: 22, region: 'Eriador' },

  // ═══ Misty Mountains & Moria ═══
  { id: 'misty_mountains', name: 'Misty Mountains', x: 47, y: 40, region: 'Misty Mountains', major: true },
  { id: 'moria', name: 'Moria (Khazad-dûm)', x: 48, y: 43, region: 'Misty Mountains', major: true },
  { id: 'high_pass', name: 'High Pass', x: 48, y: 33, region: 'Misty Mountains' },

  // ═══ Wilderland ═══
  { id: 'mirkwood', name: 'Mirkwood', x: 58, y: 30, region: 'Wilderland', major: true },
  { id: 'dol_guldur', name: 'Dol Guldur', x: 56, y: 38, region: 'Wilderland' },
  { id: 'thranduil_halls', name: "Thranduil's Halls", x: 61, y: 22, region: 'Wilderland' },
  { id: 'beorn', name: "Beorn's House", x: 53, y: 30, region: 'Wilderland' },
  { id: 'erebor', name: 'Erebor (Lonely Mountain)', x: 68, y: 22, region: 'Wilderland', major: true },
  { id: 'dale', name: 'Dale', x: 69, y: 22, region: 'Wilderland' },
  { id: 'esgaroth', name: 'Esgaroth (Lake-town)', x: 66, y: 24, region: 'Wilderland' },
  { id: 'iron_hills', name: 'Iron Hills', x: 75, y: 21, region: 'Wilderland' },

  // ═══ Lothlórien ═══
  { id: 'lothlorien', name: 'Lothlórien', x: 51, y: 44, region: 'Lothlórien', major: true },
  { id: 'caras_galadhon', name: 'Caras Galadhon', x: 52, y: 45, region: 'Lothlórien' },

  // ═══ Rohan ═══
  { id: 'edoras', name: 'Edoras (Meduseld)', x: 48, y: 55, region: 'Rohan', major: true },
  { id: 'helms_deep', name: "Helm's Deep", x: 46, y: 54, region: 'Rohan', major: true },
  { id: 'isengard', name: 'Isengard (Orthanc)', x: 46, y: 49, region: 'Rohan', major: true },
  { id: 'fangorn', name: 'Fangorn Forest', x: 49, y: 49, region: 'Rohan', major: true },
  { id: 'west_emnet', name: 'The Wold', x: 51, y: 50, region: 'Rohan' },

  // ═══ Gondor ═══
  { id: 'minas_tirith', name: 'Minas Tirith', x: 55, y: 62, region: 'Gondor', major: true },
  { id: 'osgiliath', name: 'Osgiliath', x: 56, y: 62, region: 'Gondor' },
  { id: 'dol_amroth', name: 'Dol Amroth', x: 50, y: 66, region: 'Gondor' },
  { id: 'pelargir', name: 'Pelargir', x: 54, y: 65, region: 'Gondor' },
  { id: 'amon_hen', name: 'Amon Hen', x: 53, y: 50, region: 'Gondor' },
  { id: 'argonath', name: 'Argonath', x: 53, y: 52, region: 'Gondor' },

  // ═══ Mordor ═══
  { id: 'minas_morgul', name: 'Minas Morgul', x: 60, y: 62, region: 'Mordor' },
  { id: 'cirith_ungol', name: 'Cirith Ungol', x: 61, y: 61, region: 'Mordor' },
  { id: 'morannon', name: 'Black Gate', x: 62, y: 57, region: 'Mordor', major: true },
  { id: 'mount_doom', name: 'Mount Doom (Orodruin)', x: 64, y: 62, region: 'Mordor', major: true },
  { id: 'barad_dur', name: 'Barad-dûr', x: 66, y: 61, region: 'Mordor', major: true },
  { id: 'mordor', name: 'Plateau of Gorgoroth', x: 65, y: 63, region: 'Mordor' },
  { id: 'nurn', name: 'Sea of Núrnen', x: 65, y: 67, region: 'Mordor' },

  // ═══ Far lands ═══
  { id: 'harad', name: 'Harad', x: 52, y: 76, region: 'Harad' },
  { id: 'rhun', name: 'Rhûn', x: 78, y: 50, region: 'Rhûn' },
  { id: 'umbar', name: 'Umbar', x: 47, y: 75, region: 'Harad' },
];

export { LOCATIONS };

// Parse "TA 3018" / "FA 5" into monotonic year
function parseYear(position) {
  if (!position) return null;
  const p = String(position).trim().toUpperCase();
  try {
    if (p.includes('FA')) return 3021 + parseInt(p.replace('FA', '').trim(), 10);
    if (p.includes('TA')) return parseInt(p.replace('TA', '').trim(), 10);
    const n = parseInt(p, 10);
    return Number.isNaN(n) ? null : n;
  } catch (e) { return null; }
}

// Era-aware realm territories. All paths are viewBox 0-100.
function getRealmsForYear(year) {
  if (year === null || year === undefined) year = 3018;

  // Shared free realms present in most eras
  const shire = { id: 'shire', label: 'THE SHIRE', color: '134,239,172', // leaf green
    path: 'M16,30 L25,30 L25,38 L16,38 Z',
    textX: 20, textY: 29, fontSize: 0.95 };

  const rivendell_realm = { id: 'rivendell-realm', label: 'RIVENDELL', color: '191,219,254', // pale blue
    path: 'M42,35 L46,35 L46,40 L42,40 Z',
    textX: 44, textY: 34, fontSize: 0.85, dashed: true };

  const lorien = { id: 'lorien', label: 'LOTHLÓRIEN', color: '251,191,36', // mallorn gold
    path: 'M49,42 L54,42 L54,47 L49,47 Z',
    textX: 51, textY: 49, fontSize: 0.95, dashed: true };

  const erebor_realm = { id: 'erebor-realm', label: 'EREBOR', color: '251,146,60', // dwarven copper
    path: 'M65,19 L77,19 L77,25 L65,25 Z',
    textX: 71, textY: 18, fontSize: 0.9, dashed: true };

  const mirkwood_north = { id: 'mirkwood-elves', label: "THRANDUIL'S REALM", color: '22,163,74', // deep green
    path: 'M58,18 L65,18 L65,28 L58,28 Z',
    textX: 61, textY: 17, fontSize: 0.85, dashed: true };

  if (year < 3018) {
    // ═══ The Watchful Peace (pre-3018) — free realms, dormant shadow ═══
    return [
      shire, rivendell_realm, lorien, erebor_realm, mirkwood_north,
      { id: 'gondor-peace', label: 'GONDOR', color: '229,231,235', // white city
        path: 'M48,55 L62,55 L62,68 L48,68 Z',
        textX: 55, textY: 62, fontSize: 1.3 },
      { id: 'rohan-peace', label: 'ROHAN', color: '250,204,21', // gold
        path: 'M42,48 L54,48 L54,58 L42,58 Z',
        textX: 48, textY: 54, fontSize: 1.2 },
      { id: 'mirkwood-dark', label: 'MIRKWOOD', color: '21,94,61', // shadow green
        path: 'M56,22 L62,22 L62,42 L56,42 Z',
        textX: 59, textY: 32, fontSize: 0.95, dashed: true },
      { id: 'mordor-dormant', label: 'MORDOR', color: '100,116,139', // dormant slate
        path: 'M60,55 L72,55 L72,68 L60,68 Z',
        textX: 66, textY: 62, fontSize: 1.3, dashed: true },
    ];
  }

  if (year === 3018) {
    // ═══ TA 3018 — Gathering Storm ═══
    return [
      shire, rivendell_realm, lorien, erebor_realm, mirkwood_north,
      { id: 'gondor', label: 'GONDOR', color: '229,231,235',
        path: 'M48,55 L62,55 L62,68 L48,68 Z',
        textX: 55, textY: 62, fontSize: 1.3 },
      { id: 'rohan', label: 'ROHAN', color: '250,204,21',
        path: 'M42,48 L54,48 L54,58 L42,58 Z',
        textX: 48, textY: 54, fontSize: 1.2 },
      { id: 'isengard-treachery', label: 'ISENGARD', color: '180,83,9', // rust — traitor
        path: 'M44,48 L48,48 L48,51 L44,51 Z',
        textX: 46, textY: 47, fontSize: 0.85, dashed: true },
      { id: 'dol-guldur', label: 'DOL GULDUR', color: '127,29,29', // dark red
        path: 'M54,36 L58,36 L58,40 L54,40 Z',
        textX: 56, textY: 42, fontSize: 0.85, dashed: true },
      { id: 'mordor-rising', label: 'MORDOR RISING', color: '185,28,28', // crimson
        path: 'M58,55 L72,55 L72,70 L58,70 Z',
        textX: 65, textY: 63, fontSize: 1.4 },
    ];
  }

  if (year === 3019) {
    // ═══ TA 3019 — War of the Ring at full pitch ═══
    return [
      shire, rivendell_realm, lorien, erebor_realm, mirkwood_north,
      { id: 'gondor-besieged', label: 'GONDOR BESIEGED', color: '229,231,235',
        path: 'M48,55 L60,55 L60,66 L48,66 Z',
        textX: 54, textY: 62, fontSize: 1.2 },
      { id: 'rohan-riding', label: 'ROHIRRIM RIDE', color: '250,204,21',
        path: 'M42,48 L54,48 L54,58 L42,58 Z',
        textX: 48, textY: 54, fontSize: 1.2 },
      { id: 'isengard-war', label: 'ISENGARD', color: '120,53,15', // deep rust
        path: 'M44,48 L48,48 L48,51 L44,51 Z',
        textX: 46, textY: 47, fontSize: 0.85, dashed: true },
      { id: 'dol-guldur-war', label: 'DOL GULDUR', color: '127,29,29',
        path: 'M54,36 L58,36 L58,40 L54,40 Z',
        textX: 56, textY: 42, fontSize: 0.85, dashed: true },
      { id: 'mordor-war', label: 'SAURON\'S DOMAIN', color: '185,28,28',
        path: 'M58,54 L74,54 L74,71 L58,71 Z',
        textX: 66, textY: 63, fontSize: 1.5 },
      { id: 'harad-allied', label: 'HARADRIM', color: '217,119,6', // amber-700
        path: 'M46,73 L58,73 L58,79 L46,79 Z',
        textX: 52, textY: 77, fontSize: 1.1, dashed: true },
      { id: 'rhun-allied', label: 'EASTERLINGS', color: '194,65,12',
        path: 'M74,48 L82,48 L82,54 L74,54 Z',
        textX: 78, textY: 52, fontSize: 1.0, dashed: true },
    ];
  }

  // ═══ Fourth Age (year > 3019) — Reunited Kingdom, Shadow cleansed ═══
  return [
    shire, erebor_realm,
    { id: 'reunited-kingdom', label: 'REUNITED KINGDOM', color: '229,231,235',
      path: 'M14,30 L40,30 L62,68 L48,68 L14,38 Z',
      textX: 32, textY: 45, fontSize: 1.5 },
    { id: 'rohan-ally', label: 'ROHAN (ALLY)', color: '250,204,21',
      path: 'M42,48 L54,48 L54,58 L42,58 Z',
      textX: 48, textY: 54, fontSize: 1.2 },
    { id: 'lorien-fading', label: 'LOTHLÓRIEN (FADING)', color: '251,191,36',
      path: 'M49,42 L54,42 L54,47 L49,47 Z',
      textX: 51, textY: 49, fontSize: 0.9, dashed: true, dim: true },
    { id: 'rivendell-fading', label: 'RIVENDELL (FADING)', color: '191,219,254',
      path: 'M42,35 L46,35 L46,40 L42,40 Z',
      textX: 44, textY: 34, fontSize: 0.85, dashed: true, dim: true },
    { id: 'mirkwood-healed', label: 'ERYN LASGALEN', color: '22,163,74',
      path: 'M56,18 L65,18 L65,42 L56,42 Z',
      textX: 60, textY: 30, fontSize: 0.95, dashed: true },
    { id: 'mordor-cleansed', label: 'RUINS OF MORDOR', color: '71,85,105', // slate
      path: 'M58,54 L74,54 L74,71 L58,71 Z',
      textX: 66, textY: 63, fontSize: 1.2, dashed: true, dim: true },
  ];
}

export default function MiddleEarthMap({ characterLocation, onLocationClick, worldCharacters = [], events = [], timelinePosition = '' }) {
  const containerRef = useRef(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [dragging, setDragging] = useState(false);
  const [dragStart, setDragStart] = useState(null);
  const [hovered, setHovered] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);
  const [pulsePhase, setPulsePhase] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setPulsePhase(p => (p + 1) % 100), 50);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (characterLocation && imageLoaded && containerRef.current) {
      const loc = LOCATIONS.find(l =>
        l.id === characterLocation || l.name.toLowerCase() === characterLocation?.toLowerCase()
      );
      if (loc) {
        const rect = containerRef.current.getBoundingClientRect();
        const targetZoom = 2;
        setZoom(targetZoom);
        setOffset({
          x: -(loc.x / 100 * rect.width * targetZoom - rect.width / 2),
          y: -(loc.y / 100 * rect.height * targetZoom - rect.height / 2),
        });
      }
    }
  }, [characterLocation, imageLoaded]);

  const handleWheel = useCallback((e) => {
    e.preventDefault();
    const container = containerRef.current;
    if (!container) return;
    const rect = container.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    const mouseY = e.clientY - rect.top;
    const delta = e.deltaY > 0 ? 0.9 : 1.1;
    const newZoom = Math.max(0.5, Math.min(6, zoom * delta));
    const scale = newZoom / zoom;
    setOffset(prev => ({
      x: mouseX - scale * (mouseX - prev.x),
      y: mouseY - scale * (mouseY - prev.y),
    }));
    setZoom(newZoom);
  }, [zoom]);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    el.addEventListener('wheel', handleWheel, { passive: false });
    return () => el.removeEventListener('wheel', handleWheel);
  }, [handleWheel]);

  const handleMouseDown = (e) => {
    if (e.target.closest('.location-dot')) return;
    setDragging(true);
    setDragStart({ x: e.clientX - offset.x, y: e.clientY - offset.y });
  };
  const handleMouseMove = (e) => {
    if (!dragging || !dragStart) return;
    setOffset({ x: e.clientX - dragStart.x, y: e.clientY - dragStart.y });
  };
  const handleMouseUp = () => { setDragging(false); setDragStart(null); };

  const charLoc = characterLocation ? LOCATIONS.find(l =>
    l.id === characterLocation || l.name.toLowerCase() === characterLocation?.toLowerCase()
  ) : null;

  const pulseScale = 1 + Math.sin(pulsePhase * 0.12) * 0.4;
  const pulseOpacity = 0.5 + Math.sin(pulsePhase * 0.08) * 0.3;

  const realms = getRealmsForYear(parseYear(timelinePosition));

  return (
    <div
      ref={containerRef}
      className="w-full h-full overflow-hidden relative"
      style={{ cursor: dragging ? 'grabbing' : 'grab', backgroundColor: '#0f1a0f' }}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
      data-testid="middle-earth-map"
    >
      <div
        className="absolute will-change-transform"
        style={{
          transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
          transformOrigin: '0 0',
          width: '100%',
          height: '100%',
          transition: dragging ? 'none' : 'transform 0.1s ease-out',
        }}
      >
        {/* Parchment fallback — mossy greens and stone greys */}
        <div
          className="absolute inset-0"
          style={{
            background: 'radial-gradient(ellipse at center, #2d3321 0%, #0f1a0f 80%)',
            backgroundImage: `
              radial-gradient(circle at 20% 30%, rgba(120,145,85,0.1) 0%, transparent 50%),
              radial-gradient(circle at 70% 60%, rgba(80,72,45,0.12) 0%, transparent 50%)
            `,
          }}
        />

        {!imageFailed && (
          <img
            src={MIDDLE_EARTH_IMAGE}
            alt="Middle-earth"
            className="w-full h-full object-cover select-none pointer-events-none"
            draggable={false}
            onLoad={() => setImageLoaded(true)}
            onError={() => { setImageFailed(true); setImageLoaded(true); }}
            style={{
              opacity: imageLoaded && !imageFailed ? 0.55 : 0,
              transition: 'opacity 0.5s',
              filter: 'sepia(0.35) brightness(0.7) contrast(1.1) saturate(0.9)',
            }}
          />
        )}

        {imageLoaded && !imageFailed && (
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'radial-gradient(ellipse at center, rgba(15,25,15,0.35) 0%, rgba(6,12,6,0.75) 100%)',
              mixBlendMode: 'multiply',
            }}
          />
        )}

        {/* Realm borders — dynamic based on era */}
        {imageLoaded && (
          <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox="0 0 100 100" preserveAspectRatio="none">
            <defs>
              <filter id="me-realm-glow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="0.6" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>
            {realms.map((r) => {
              const opacityMul = r.dim ? 0.55 : 1;
              return (
                <g key={r.id}>
                  <path
                    d={r.path}
                    fill="none"
                    stroke="rgba(0,0,0,0.75)"
                    strokeWidth={r.dashed ? 0.85 : 1.2}
                    strokeLinejoin="round"
                  />
                  <path
                    d={r.path}
                    fill={`rgba(${r.color},${0.14 * opacityMul})`}
                    stroke={`rgba(${r.color},${0.95 * opacityMul})`}
                    strokeWidth={r.dashed ? 0.5 : 0.75}
                    strokeDasharray={r.dashed ? '0.7 0.7' : '1.2 0.5'}
                    strokeLinejoin="round"
                    filter="url(#me-realm-glow)"
                  />
                  <text
                    x={r.textX}
                    y={r.textY}
                    textAnchor="middle"
                    fill="rgba(0,0,0,0.9)"
                    stroke="rgba(0,0,0,0.9)"
                    strokeWidth={0.3}
                    fontSize={r.fontSize}
                    fontFamily="serif"
                    fontWeight="bold"
                    letterSpacing="0.15"
                  >
                    {r.label}
                  </text>
                  <text
                    x={r.textX}
                    y={r.textY}
                    textAnchor="middle"
                    fill={`rgba(${r.color},${0.98 * opacityMul})`}
                    fontSize={r.fontSize}
                    fontFamily="serif"
                    fontWeight="bold"
                    letterSpacing="0.15"
                    filter="url(#me-realm-glow)"
                  >
                    {r.label}
                  </text>
                </g>
              );
            })}
          </svg>
        )}

        {/* Location markers */}
        {imageLoaded && LOCATIONS.filter(l => l.major).map(loc => {
          const isHovered = hovered === loc.id;
          const isCharHere = charLoc?.id === loc.id;
          const dotSize = loc.major ? 6 : 3;
          const regionColor = {
            'The Shire': '#86efac',
            'Eriador': '#a7f3d0',
            'Misty Mountains': '#cbd5e1',
            'Wilderland': '#bef264',
            'Lothlórien': '#fcd34d',
            'Rohan': '#fbbf24',
            'Gondor': '#f1f5f9',
            'Mordor': '#ef4444',
            'Harad': '#d97706',
            'Rhûn': '#ea580c',
          }[loc.region] || '#d1d5db';

          return (
            <div
              key={loc.id}
              className="location-dot absolute"
              style={{
                left: `${loc.x}%`,
                top: `${loc.y}%`,
                transform: 'translate(-50%, -50%)',
                zIndex: isHovered || isCharHere ? 20 : 10,
              }}
              onMouseEnter={() => setHovered(loc.id)}
              onMouseLeave={() => setHovered(null)}
              onClick={(e) => { e.stopPropagation(); onLocationClick?.(loc); }}
              data-testid={`location-${loc.id}`}
            >
              {isCharHere && (
                <>
                  <div className="absolute rounded-full" style={{
                    left: '50%', top: '50%',
                    width: `${20 * pulseScale}px`, height: `${20 * pulseScale}px`,
                    transform: 'translate(-50%, -50%)',
                    border: '1px solid #fcd34d',
                    opacity: pulseOpacity * 0.55,
                  }} />
                  <div className="absolute rounded-full" style={{
                    left: '50%', top: '50%',
                    width: `${32 * pulseScale}px`, height: `${32 * pulseScale}px`,
                    transform: 'translate(-50%, -50%)',
                    border: '1px solid #fcd34d',
                    opacity: pulseOpacity * 0.3,
                  }} />
                  <div className="absolute rounded-full" style={{
                    left: '50%', top: '50%',
                    width: '14px', height: '14px',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'rgba(252,211,77,0.3)',
                  }} />
                </>
              )}

              <div
                className="rounded-full cursor-pointer transition-all duration-150"
                style={{
                  width: `${isHovered ? dotSize + 4 : dotSize}px`,
                  height: `${isHovered ? dotSize + 4 : dotSize}px`,
                  backgroundColor: isCharHere ? '#fcd34d' : regionColor,
                  boxShadow: `0 0 ${isHovered ? 12 : loc.major ? 8 : 4}px ${regionColor}, 0 0 ${isHovered ? 20 : loc.major ? 12 : 0}px ${regionColor}`,
                  border: loc.major ? '1px solid rgba(255,255,255,0.35)' : 'none',
                }}
              />

              {(isHovered || (loc.major && zoom >= 1.2) || isCharHere) && (
                <div
                  className="absolute left-1/2 -translate-x-1/2 whitespace-nowrap pointer-events-none"
                  style={{ bottom: `${(isHovered ? dotSize + 8 : dotSize + 4)}px` }}
                >
                  <span
                    className="px-1.5 py-0.5 rounded"
                    style={{
                      fontFamily: 'serif',
                      fontSize: isHovered ? '11px' : '9px',
                      color: isCharHere ? '#fef3c7' : isHovered ? '#ffffff' : '#ecfccb',
                      backgroundColor: isHovered ? 'rgba(0,0,0,0.88)' : 'rgba(0,0,0,0.6)',
                      fontWeight: isCharHere ? 'bold' : 600,
                      textShadow: '0 0 4px rgba(0,0,0,0.95), 0 1px 2px rgba(0,0,0,0.9)',
                      letterSpacing: '0.03em',
                    }}
                  >
                    {loc.name}
                  </span>
                </div>
              )}

              {isHovered && (
                <div
                  className="absolute left-full ml-2 top-1/2 -translate-y-1/2 bg-black/90 border border-amber-700/30 rounded px-2 py-1 whitespace-nowrap pointer-events-none z-50"
                  style={{ minWidth: '80px' }}
                >
                  <div className="text-[10px] font-serif italic text-amber-200/70">{loc.region}</div>
                  <div className="text-xs font-serif font-bold text-white">{loc.name}</div>
                  {isCharHere && <div className="text-[10px] font-serif text-amber-400 mt-0.5">You are here</div>}
                </div>
              )}
            </div>
          );
        })}

        {/* Event markers */}
        {imageLoaded && events.map((evt, i) => {
          const loc = LOCATIONS.find(l =>
            l.id === evt.system_id || l.name?.toLowerCase() === evt.system_id?.toLowerCase()
          );
          if (!loc) return null;
          return (
            <div
              key={`evt-${i}`}
              className="absolute pointer-events-none"
              style={{ left: `${loc.x}%`, top: `${loc.y}%`, transform: 'translate(-50%, -50%)', zIndex: 5 }}
            >
              <div
                className="rounded-full border-2 border-dashed border-red-400"
                style={{
                  width: '22px', height: '22px',
                  opacity: 0.6 + Math.sin(pulsePhase * 0.1 + i) * 0.3,
                  boxShadow: '0 0 8px rgba(248,113,113,0.6)',
                }}
              />
              <div
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 text-[9px] font-serif font-bold text-red-200 whitespace-nowrap px-1 rounded"
                style={{ backgroundColor: 'rgba(0,0,0,0.75)', textShadow: '0 0 4px rgba(0,0,0,0.95)' }}
              >
                {evt.label}
              </div>
            </div>
          );
        })}

        {/* Other characters in the world */}
        {imageLoaded && worldCharacters.filter(c => c.location).map(char => {
          const loc = LOCATIONS.find(l =>
            l.id === char.location || l.name?.toLowerCase() === char.location?.toLowerCase()
          );
          if (!loc) return null;
          return (
            <div
              key={char.character_id}
              className="absolute pointer-events-none"
              style={{ left: `${loc.x}%`, top: `${loc.y}%`, transform: 'translate(-50%, -50%)', zIndex: 15 }}
            >
              <div
                className="w-3.5 h-3.5 rounded-full border-2 border-orange-300"
                style={{ backgroundColor: 'rgba(251,146,60,0.4)', boxShadow: '0 0 6px rgba(251,146,60,0.8)' }}
              />
              <div
                className="absolute left-1/2 -translate-x-1/2 top-full mt-1 text-[9px] font-serif font-bold text-orange-200 whitespace-nowrap px-1 rounded"
                style={{ backgroundColor: 'rgba(0,0,0,0.7)', textShadow: '0 0 4px rgba(0,0,0,0.95)' }}
              >
                {char.name}
              </div>
            </div>
          );
        })}
      </div>

      <div className="absolute bottom-3 right-3 text-[10px] font-serif italic text-amber-700/70 bg-black/50 px-2 py-1 rounded pointer-events-none">
        {(zoom * 100).toFixed(0)}%
      </div>
    </div>
  );
}
